<template>
  <div>
    <div>
      <CoverBg
        show-text
        title="Vacancies"
        text="Our doors are open to new specialists who look for new opportunities and experience"
      />
      <b-container class="main-container content-padding-t-b-100">
        <Loading v-if="loading" />
        <VacanciesItem
          v-else
          :vacancy="currentVacancy"
          class="mb-0"
          show-context-details
        />
      </b-container>
      <CoverBg bg="cover-bg-page-bottom" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import CoverBg from '@/components/CoverBg';
import VacanciesItem from '@/components/Vacancies/VacanciesItem';
import Loading from '@/components/Loading';

export default {
  name: 'VacancyDetails',
  components: {
    Loading,
    VacanciesItem,
    CoverBg,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapState({
      currentVacancy: (state) => state.vacancies.currentVacancy,
    }),
    vacancyId() {
      return this.$route.query?.id;
    },
  },
  created() {
    this.loading = true;
    this.getVacancyById(this.vacancyId);
    this.loading = false;
  },
  methods: {
    ...mapActions([
      'getVacancyById',
    ]),
  },
};
</script>
